import { injectable, inject } from 'inversify';
import { type IDispatcher } from '@creditflowresearch/json-rpc-dispatcher/dispatcher-cfr';
import DITypes from '@creditflowresearch/json-rpc-dispatcher/dispatcher-cfr/DITypes';
import Request from '@framework/api/Rpc/Request';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import type { IRoadshowsPayload } from '@/creditflowresearch/application/Roadshows/vo/IRoadshowsPayload';
import type { IRoadshowsResponse } from '@/creditflowresearch/application/Roadshows/vo/IRoadshowsResponse';
import { withServerCache } from '@/creditflowresearch/infrastructure/cache/withServerCache';
import type { IServerCacheOptions } from '@/creditflowresearch/infrastructure/cache/withServerCache';

@injectable()
class RoadshowRepository {
  constructor(@inject(DITypes.JsonRpcDispatcher) private readonly rpc: IDispatcher) {}

  @withServerCache({
    scope: 'Roadshow',
    ttlSeconds: 180,
    maxEntries: 25,
    anonymousOnly: true,
  })
  async getAllRoadshows(
    payload: IRoadshowsPayload,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- Need for decorator
    _cacheOptions?: IServerCacheOptions,
  ): Promise<IRoadshowsResponse> {
    const request = new Request('finsight_web.market.roadshow.get_all', payload);
    const response = await this.rpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  }
}

export default RoadshowRepository;
